import type {
  FormBlock,
  FormErrors,
  FormInputType,
  FormOnValidate,
  FormValues,
} from '@/components/UI/Form/types'

import isValidEmail from './isValidEmail'

const INVALID_EMAIL_ADDRESS_ERROR_MESSAGE = 'Invalid email address'
const MATCHING_EMAIL_ADDRESS_ERROR_MESSAGE = 'Email addresses do not match'
const SAME_EMAIL_ADDRESS_ERROR_MESSAGE =
  'Parent email address cannot be your own account email address'

export default function getRequestParentContactFormInputs(): FormBlock[] {
  const inputs: FormInputType[] = [
    {
      label: `Parent's first name`,
      type: 'text',
      name: 'parent_first_name',
      placeholder: `Your parent's first name`,
      required: true,
      size: 3,
    },
    {
      label: `Parent's last name`,
      type: 'text',
      name: 'parent_last_name',
      placeholder: `Your parent's last name`,
      required: true,
      size: 3,
    },
    {
      label: `Parent's email address`,
      type: 'text',
      name: 'parent_email',
      placeholder: `Your parent's email address`,
      required: true,
      size: 3,
    },
    {
      label: `Confirm parent's email address`,
      type: 'text',
      name: 'confirm_parent_email',
      placeholder: `Confirm your parent's email address`,
      required: true,
      size: 3,
    },
  ]

  return inputs
}

export function getRequestParentContactOnValidate({
  userEmail,
}: {
  userEmail: string
}): FormOnValidate {
  return (values: FormValues, errors: FormErrors | null) => {
    if (errors != null) {
      return null
    }

    const { parent_email, confirm_parent_email } = values

    const errorsRecord: FormErrors = {}

    if (`${parent_email}`.toLowerCase() === userEmail.toLowerCase()) {
      errorsRecord.parent_email = SAME_EMAIL_ADDRESS_ERROR_MESSAGE
      return {
        errors: errorsRecord,
        message: SAME_EMAIL_ADDRESS_ERROR_MESSAGE,
      }
    }

    if (parent_email !== confirm_parent_email) {
      errorsRecord.confirm_parent_email = MATCHING_EMAIL_ADDRESS_ERROR_MESSAGE
      return {
        errors: errorsRecord,
        message: MATCHING_EMAIL_ADDRESS_ERROR_MESSAGE,
      }
    }

    if (!isValidEmail(`${parent_email}`)) {
      errorsRecord.parent_email = INVALID_EMAIL_ADDRESS_ERROR_MESSAGE
      return {
        errors: errorsRecord,
        message: INVALID_EMAIL_ADDRESS_ERROR_MESSAGE,
      }
    }

    return null
  }
}
